import React from 'react';
import { Lock } from 'lucide-react';
import { usePremium } from '../Subscription/PremiumProvider';
import { isLocked } from '../../lib/premiumLock';

const AssociatedTopics = ({ topics }) => {
  const { isPremium, isLoading } = usePremium();

  if (!topics || topics.length === 0) {
    return null;
  }

  const renderRelation = (topic) => {
    if (isLocked(topic, isPremium, isLoading)) {
      return (
        <p className="text-gray-300 text-xs leading-relaxed inline-flex items-center gap-1">
          <Lock size={10} aria-hidden="true" />
          Premium connection
        </p>
      );
    }
    if (!topic.relation_description) return null;
    return (
      <p className="text-gray-300 text-xs leading-relaxed">
        {topic.relation_description}
      </p>
    );
  };
  
  return (
    <div className="flex -space-x-2">
      {topics.slice(0, 3).map((topic) => (
        <div
          key={topic.id}
          className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-800 border-2 border-white relative group"
        >
          {topic.name.charAt(0).toUpperCase()}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-neutral-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-normal min-w-[150px] max-w-xs z-10 p-3">
            <p className="font-medium mb-1">{topic.name}</p>
            {renderRelation(topic)}
          </div>
        </div>
      ))}
      {topics.length > 3 && (
        <div 
          className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-xs font-medium text-gray-800 border-2 border-white relative group"
        >
          +{topics.length - 3}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-neutral-900 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-normal max-w-xs z-10 p-3">
            {topics.slice(3).map(t => (
              <div key={t.id} className="mb-3 last:mb-0">
                <p className="font-medium mb-1">{t.name}</p>
                {renderRelation(t)}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AssociatedTopics;
